import React, { Component } from "react"
import { Grid } from "@material-ui/core"
import Text from "../../atoms/Text"
import ContentCard from "../../molecules/ContentCard"

export default class MainContents extends Component {
  render() {
    return (
      <Grid>
        <Grid style={{ display: "flex", justifyContent: "center" }}>
          <ContentCard name="自由研究">
            <Text>
              ブランドについて自由に仮説をたて、個人orグループによる研究を行なっています。
            </Text>
            <Text hidden />
            <br />
            <Text>テーマ例）</Text>
            <Text>・まちづくりとブランド</Text>
            <Text>・渋谷のブランドに迫る</Text>
            <Text>・広島におけるスポーツチームのブランド形成について</Text>
          </ContentCard>
        </Grid>
        <Grid style={{ display: "flex", justifyContent: "center" }}>
          <ContentCard name="MBF">
            <Text>毎月開催される先生主催の勉強会に参加します。</Text>
            <Text>
              経営者や芸術家など様々な著名人をお呼びしてブランドに関する講演していただきます。
            </Text>
            <Text inlineBox>詳しくは</Text>
            <a href="https://mbforum.jp/" target="_blank">
              こちら
            </a>
            <Text inlineBox>からご覧ください。</Text>
          </ContentCard>
        </Grid>
        <Grid style={{ display: "flex", justifyContent: "center" }}>
          <ContentCard name="BRLandscape">
            <Text>一部有志によりブランド研究を行なっています。</Text>
            <Text>
              企業と協力しブランド調査の設計・分析・実施を行い、生活者の頭の中にある企業や製品への愛着の源泉、ブランド間の関係性について迫ります。
            </Text>
          </ContentCard>
        </Grid>
        <Grid style={{ display: "flex", justifyContent: "center" }}>
          <ContentCard name="社会人ゼミ">
            <Text>一般の社会人の方とブランドについて探ります。</Text>
            <Text>
            実際に企業等においてブランディングやマーケティングに携わる方々と対等な立場で議論することの出来る場です。月一回程度開催され、希望者は誰でも参加可能です。
            </Text>
          </ContentCard>
        </Grid>
      </Grid>
    )
  }
}
